 export function validateMatch(password1, password2) {
     let result = password2 === password1 ? true : false;
     return result;
 }

 export function validateLength(password, minlen) {
     let result = password.length >= minlen ? true : false;
     return result;
 }

 export function validateCharExists(password) {
     let result = password.match(/\w+/) ? true : false;
     return result;
 }

 export function validateDigitExists(password) {
     let result = password.match(/\d+/) ? true : false;
     return result;
 }
